/<template>
<as-toolbar>
    <div class="as-toolbar__item">
      <img src="https://cdn.freebiesupply.com/logos/large/2x/telus-1-logo-black-and-white.png"
        style="width: 130px; height: 130px;"
        alt="Logo" />
        <p class="yellow" > Powered by Anagraph </p>
    </div>
    <!-- <p class="as-toolbar__item">Paragraph</p>
    <a href="./default.html" class="as-toolbar__item"></a>
    <a href="./light.html" class="as-toolbar__item"></a>
    <a href="./dark.html" class="as-toolbar__item right">Powered by Anagraph</a> -->
    <i class="as-toolbar__item as-icon as-icon-points"></i>
</as-toolbar>
</template>

<script>
export default {
  name: 'Toolbar'
}
</script>

<style>
.yellow {
  font-size: 0.7rem;
  font-style: italic;
  color: #FEC503;
}
</style>
